import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            blanks: [],
            activeTab: 'active',
            successGenerate: false,
            lastUrl: null,
        }
    },
    getters: {
        activeTab: (state) => {
            return state.activeTab;
        },
        successGenerate: (state) => {
            return state.successGenerate;
        }
    },
    mutations: {
        setBlanks(state, value) {
            state.blanks = value;
        },
        addBlank(state, value) {
            state.blanks.data.unshift(value);
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/promo-codes-blank', payload)
                    .then((response) => {
                        commit('setBlanks', response.data);
                        state.lastUrl = response.data[0]?.fileUrl ?? null;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        createBlank({state, commit, getters}, pagesToGenerate){
            return new Promise((resolve, reject) => {
                ApiService.post('/promo-codes-blank', pagesToGenerate)
                    .then((response) => {
                        state.lastUrl = response.data.fileUrl ?? null;
                        commit('addBlank',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    })
            });
        },
    }
};
